import { request } from '@/libs/api-request'

export function getSurvey (params, force) {
  let url = '/ba/survey/get_survey'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function checkTempData (params, force) {
  let url = '/ba/survey/check_temp_data'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSurveyList (params, force) {
  let url = '/ba/survey/get_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function updateSurveyStatus (params, force) {
  let url = '/ba/survey/update_status'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function createSurvey (params, force) {
  let url = '/ba/survey/create'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function updateSurvey (params, force) {
  let url = '/ba/survey/update'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function deleteSurvey (params, force) {
  let url = '/ba/survey/delete_survey'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSurveyPalette (params, force) {
  let url = '/ba/survey/get_palette'

  const config = {
    method: 'get',
    url,
    data: params
  }

  return request(config, force)
}

export function checkInRanking (params, force) {
  let url = '/ba/survey/check_ranking'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getResponseSummary (params, force) {
  let url = '/ba/survey/get_result_summary'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getQuestionCountByDelete (params, force) {
  let url = '/ba/survey/confirm_delete_question'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTextAnswer (params, force) {
  let url = '/ba/survey/get_text_answer'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getUrlEtcRank (params, force) {
  let url = '/ba/survey/get_url_rank_etc'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getIndividualAnswer (params, force) {
  let url = '/ba/survey/get_individual'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAllAnswer (params, force) {
  let url = '/ba/survey/get_all_answers'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
